export default __webpack_public_path__ + "static/media/leaf.6500c6aa.jpg";